// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FinancialScreeningResultSearchBase } from './financialScreeningResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningResultSearchResponse {
    'results'?: Array<FinancialScreeningResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<FinancialScreeningResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningResultSearchResponse.attributeTypeMap;
    }
}
